import { ApiLambdalerAuthHeaderWithRequestActorSchema } from '@eigtech/lambdaler-api-gateway-types';
import { z } from 'zod';
import { InspectionCornSchema, InspectionEntityCornSchema } from '../base.js';
import { NoteSchema } from '../entities/note.js';
export const CreateNoteBodySchema = z.object({
    title: z.string().optional(),
    text: z.string(),
});
export const CreateNoteApiSchema = {
    params: z.object({
        entityId: InspectionEntityCornSchema,
        inspectionId: InspectionCornSchema,
    }),
    query: z.object({}),
    headers: ApiLambdalerAuthHeaderWithRequestActorSchema,
    body: CreateNoteBodySchema,
    response: NoteSchema,
};
export const CreateNoteRequestSchema = CreateNoteApiSchema.params
    .merge(CreateNoteApiSchema.body)
    .merge(CreateNoteApiSchema.headers);
